import { z } from 'zod';
import { EnumSchema, FromSchema, PolicyType } from '@40seas/entities/common';
import { PolicyResultStatus } from './policy.result.status';
import { ProcessType } from '../process/process.type';

export const PolicyResultSchema = z.object({
    policyType: EnumSchema(PolicyType),
    status: EnumSchema(PolicyResultStatus),
    creditMatch: z.number().optional(),
    processesTypes: z.array(EnumSchema(ProcessType)).optional(),
    version: z.number().optional(),
});

export class PolicyResult extends FromSchema(PolicyResultSchema) {
    policyType: PolicyType;
    status: PolicyResultStatus;
    creditMatch?: number;
    processesTypes?: ProcessType[];
    version?: number;
}
